// header js


function closedrawer(drawer) {
  // drawer.stopPropagation();
  drawer.closest('cart-drawer').close();
  console.log(drawer.closest('cart-drawer').previousElementSibling);
  drawer.closest('cart-drawer').previousElementSibling.classList.remove('active');

  setTimeout(() => {
    drawer.closest('cart-drawer').previousElementSibling.classList.remove('active');
  }, 1000);
}


const hamburger = document.getElementById('hamburger-menu');
const line = document.querySelectorAll('.line');
const megamanuheaderitem = document.querySelector('.mega_manu_header_items')
const hamburgermenu = document.querySelector('.hamburger-menu')
const closebutton = document.querySelector('.close-button')
const body = document.querySelector("body");
const header_overlay = document.querySelector(".header_overlay")
const cart_icon = document.querySelector(".cart_image")


if (header_overlay) {
  header_overlay.addEventListener("click", () => {
    megamanuheaderitem.classList.remove('open');
    megamanuheaderitem.classList.remove('open')
    body.classList.remove('refine')
    if (hamburgermenu.classList.contains('none')) {
      setTimeout(() => {
        hamburgermenu.classList.remove('none')
      }, 200)
    }
    header_overlay.classList.remove("open")
  })
}

function updateDateTime() {
  const dateElement = document.getElementById('date');
  const timeElement = document.getElementById('time');

  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: '2-digit',
  };

  const now = new Date();
  const formattedDate = now.toLocaleDateString(undefined, options);
  const formattedTime = now.toLocaleTimeString(undefined, {
    hour12: true,
    hour: '2-digit',
    minute: '2-digit',
  });

  dateElement.textContent = formattedDate;
  timeElement.textContent = formattedTime;
}

updateDateTime();
setInterval(updateDateTime, 60000);

// collection filter js

const refine_text = document.querySelector(".refine_text")
const refine_data = document.querySelector(".refine_data")
const collection_overlay = document.querySelector(".collection_overlay")
const close_filter_collection = document.querySelector(".close_filter_collection")

if (refine_text) {
  refine_text.addEventListener("click", () => {
    refine_data.classList.toggle("refine");
    collection_overlay.classList.toggle("refine");
    body.classList.toggle("refine");
  })
}
if (collection_overlay) {
  collection_overlay.addEventListener("click", () => {
    refine_data.classList.remove("refine");
    collection_overlay.classList.remove("refine");
    body.classList.remove("refine");
  })
}

if (close_filter_collection) {
  close_filter_collection.addEventListener("click", () => {
    refine_data.classList.remove("refine");
    collection_overlay.classList.remove("refine");
    body.classList.remove("refine");
  })
}



// collection accordian js
const accordionItemHeaders = document.querySelectorAll(".collection_accordion-item-header");

accordionItemHeaders.forEach((accordionItemHeader) => {
  accordionItemHeader.addEventListener("click", (event) => {

    const currentlyActiveAccordionItemHeader = document.querySelector(".collection_accordion-item-header.active")
    accordionItemHeader.classList.toggle("active");
    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
      //   accordionItemBody.style.overflow = "auto";
    } else {
      accordionItemBody.style.maxHeight = 0;
    }
  });
});


// Product page accordian

const accordionItemsubHeaders = document.querySelectorAll(".product_accordion-item-header");

accordionItemsubHeaders.forEach((accordionItemHeader) => {
  accordionItemHeader.addEventListener("click", (event) => {

    const currentlyActiveAccordionItemHeader = document.querySelector(".collection_accordion-item-header.active")
    accordionItemHeader.classList.toggle("active");
    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
      //   accordionItemBody.style.overflow = "auto";
    } else {
      accordionItemBody.style.maxHeight = 0;
    }
  });
});

const forgetpassword = document.querySelector(".login_password_forget")
const loginforgetpassword = document.querySelector(".login_forget_password_page")
const signalldata = document.querySelector(".sign_all_data")

if (forgetpassword) {
  forgetpassword.addEventListener("click", () => {
    loginforgetpassword.classList.add("visible")
    signalldata.classList.add("novisible")
  })

}

const checkbox = document.querySelector(".term_and_condition input");
const create_password_btn = document.querySelector(".create_password_btn")

if (checkbox) {
  checkbox.addEventListener("change", () => {
    if (checkbox.checked) {
      create_password_btn.removeAttribute('disabled');
    } else {
      create_password_btn.setAttribute('disabled', true);
    }
  })
}





// Filter

var fltBtn = document.querySelectorAll('.heading_box');
fltBtn.forEach(btn => {
  btn.addEventListener('click', function () {
    var ul = this.closest('.filter_set').querySelector('.filter_wrapper');
    var ulWrapper = ul.querySelector('ul').getBoundingClientRect().height;
    var span = this.querySelector('span')
    if (ul.style.height <= '0px') {
      ul.style.height = ulWrapper + 'px';
      span.classList.add('minus');
    } else {
      ul.style.height = 0 + 'px';
      span.classList.remove('minus');
    }
  })
})


// sold out

var btns = document.querySelectorAll('.sold_sale_box label');
var collectionPdts = document.querySelectorAll('.main_collection_page_items .main_collection_page_item1');

btns.forEach(btn => {
  btn.addEventListener('click', function (e) {
    let find = this.getAttribute('for');
    var input = this.querySelector('input');
    if (input.checked) {
      collectionPdts.forEach((pdt) => {
        if (pdt.hasAttribute(find)) {
          pdt.classList.add('visually-hidden');
        }
      });
    } else {
      collectionPdts.forEach((pdt) => {
        pdt.classList.remove('visually-hidden');
      });
    }
  })
})


// account

var list = document.querySelectorAll('.new_account_page_item1 li');

list.forEach(li => {
  li.querySelector('.list-heading').addEventListener('click', function () {
    var text = li.querySelector('.list-text_wrapper');
    var textHt = li.querySelector('.list-text').getBoundingClientRect().height;
    if (text.getBoundingClientRect().height <= 0) {
      text.style.height = textHt + 'px';
    } else
      text.style.height = 0;
  })
})


// Product Variant 

var productSelect = document.querySelector('.size_selector_in_size');
if (productSelect) {
  var addBag = document.querySelector('.add_to_bag_btn');
  var optList = productSelect.querySelector('.option_list');

  var masterSelect = document.querySelector('#masterselect');


  // masterSelect.addEventListener('change', function () {
  //   if (masterSelect.value != '') {
  //     addBag.setAttribute('type', 'submit')
  //   }
  // })


  addBag.addEventListener('click', function () {
    if (masterSelect.value == '') {
      document.querySelector(".size_selector").classList.add('error');
      alert('No more units available.');
    }
  })

  productSelect.addEventListener('click', function () {
    optList.classList.toggle('hidden');
    if (screen.width < 1024) {
      if (!optList.classList.contains('hidden')) {
        document.querySelector('.color_box').style.display = 'none';
        document.querySelector('.size_selector').style.width = '100%';
      } else {
        document.querySelector('.color_box').style.display = '';
        document.querySelector('.size_selector').style.width = '50%';
      }
    };
    //AKJ COLOR
    colorBox.classList.remove('show');
    if (document.querySelector('.metaBox.show')) {
      document.querySelector('.metaBox.show').classList.remove('show');
    }
    document.querySelector(".size_selector").classList.remove('error');

  })

  optList.querySelectorAll('.option').forEach(opt => {
    opt.addEventListener('click', function () {
      // console.log(opt.textContent);
      addBag.setAttribute('type', 'submit')
      if (opt.hasAttribute('disabled')) {
        optList.classList.add('hidden');
      } else {
        productSelect.querySelector('.show_value').textContent = opt.textContent
        var value = opt.getAttribute('span-value');
        masterSelect.value = value
      }
    })
  })

}